import script from "./InformationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationTable.vue?vue&type=script&setup=true&lang=js"

import "./InformationTable.vue?vue&type=style&index=0&id=af33ea16&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af33ea16"]])

export default __exports__